// extracted by mini-css-extract-plugin
export default {"work":"Work_work__B7N9z","container":"Work_container__7HhBa","experience":"Work_experience__IUqgl","head":"Work_head__x5tJg","role":"Work_role__fW28L","stack":"Work_stack__ih0Cr"};